import { useState } from "react";
import { UserRound, Map as MapIcon, List, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import CitySelector from "@/components/jobbkarta/CitySelector";
import GuideOfferDialog from "@/components/jobbkarta/GuideOfferDialog";

export default function Header({
  compact,
  cities,
  selected,
  onToggle,
  view,
  onViewChange,
  onOpenProfile,
  onHome,
}) {
  const [guideInfoOpen, setGuideInfoOpen] = useState(false);
  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-[1100] border-b border-slate-200 bg-white/80 backdrop-blur-md"
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between gap-3 px-4 sm:px-6">
        <button
          onClick={onHome}
          data-testid="header-logo"
          className="flex items-center font-display text-xl font-extrabold tracking-tight text-slate-900"
        >
          Spontan<span className="text-emerald-600">.</span>
        </button>

        <div className="flex items-center gap-2">
          {compact && (
            <>
              <div className="hidden sm:block">
                <CitySelector presets={cities} selected={selected} onToggle={onToggle} />
              </div>
              <div
                className="flex items-center rounded-full border border-slate-200 bg-slate-50 p-0.5"
                role="tablist"
              >
                <button
                  data-testid="toggle-list-view"
                  onClick={() => onViewChange("list")}
                  className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm transition-colors md:hidden ${
                    view === "list" ? "bg-white text-slate-900 shadow-sm" : "text-slate-500"
                  }`}
                >
                  <List className="h-4 w-4" /> Lista
                </button>
                <button
                  data-testid="toggle-map-view"
                  onClick={() => onViewChange("map")}
                  className={`flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm transition-colors md:hidden ${
                    view === "map" ? "bg-white text-slate-900 shadow-sm" : "text-slate-500"
                  }`}
                >
                  <MapIcon className="h-4 w-4" /> Karta
                </button>
              </div>
            </>
          )}
          <Button
            variant="outline"
            onClick={() => setGuideInfoOpen(true)}
            data-testid="header-buy-guide"
            className="hidden gap-1.5 rounded-full border-emerald-300 text-emerald-700 hover:bg-emerald-50 hover:text-emerald-800 sm:inline-flex"
          >
            <FileText className="h-4 w-4" /> Uppföljningsguide · 89 kr
          </Button>
          <Button
            variant="outline"
            size="icon"
            onClick={onOpenProfile}
            data-testid="profile-modal-trigger"
            className="rounded-full border-slate-300"
            aria-label="Din profil"
          >
            <UserRound className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {compact && (
        <div className="border-t border-slate-100 px-4 py-2 sm:hidden">
          <CitySelector presets={cities} selected={selected} onToggle={onToggle} triggerClassName="w-full justify-center" />
        </div>
      )}

      <GuideOfferDialog open={guideInfoOpen} onOpenChange={setGuideInfoOpen} variant="info" />
    </header>
  );
}
